import React, { useEffect } from 'react';
import { formatUTCDate } from '../../utils/utils';

/**
 * The whole of one member's message (feature 067-user-feedback-tabs).
 *
 * The list column shows the first 200 characters. THIS IS THE ONLY PLACE A LONGER MESSAGE CAN BE
 * READ — the Firebase tab has no detail page — so nothing here may truncate, collapse or reflow
 * the text. Line breaks are the member's own paragraphing and are preserved with `pre-wrap`.
 *
 * Text is rendered as TEXT. React escapes by default and that default IS the security control:
 * this is untrusted member input, so dangerouslySetInnerHTML must never appear in this file
 * (FR-033).
 *
 * Built on the shared `au-modal` styling, and on the same close contract as the survey detail
 * modal it sits beside: the close button, the backdrop and Escape all dismiss it, while a click
 * inside the panel does not.
 */
export default function FirebaseMessageModal({ item, onClose }) {
  // Registered unconditionally — hooks cannot be skipped for the closed case, so the handler
  // itself checks whether there is anything open to close.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && item) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [item, onClose]);

  if (!item) return null;

  const when = formatUTCDate(item.created_display);

  return (
    <div className="au-modal-bg" data-testid="ff-modal-bg" onClick={onClose}>
      <div
        className="au-modal ff-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Feedback message"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="au-modal-close" aria-label="Close" onClick={onClose}>×</button>

        <h3 className="au-modal-title">
          {item.title || <span className="ff-unavailable">Untitled</span>}
        </h3>

        <p className="ff-modal-sub">
          <span>{item.user_name || 'Not provided'}</span>
          {item.user_email && <span> · {item.user_email}</span>}
          <span> · {when || 'Unknown'}</span>
        </p>

        <div className="ff-modal-message" data-testid="ff-modal-message">{item.message}</div>
      </div>
    </div>
  );
}
